<template lang="html">
<div class="reservation-component">

  <div class="row div-reservation">
    <form class="form-div-reservation">
      <h4 v-if="header && headerTitle == ''" class="header-reservation"> {{$t('reserva.reserva_vagas')}} </h4>
      <h4 v-else-if="header != false" class="header-reservation">{{ headerTitle }}</h4>
      <hr v-if="header == true">
      <p class="desconto">{{$t('reserva.desconto')}}</p>

      <div class="form-row">

        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
          <label for="datepicker-in">{{$t('reserva.entrada')}}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <img src="../../assets/png/glyphicons-46-calendar.png" class="img-input" alt="Check-in">
              </div>
            </div>
            <datepicker
              id="datepicker-in"
              class="input-datepicker"
              :language="lang"
              :disabledDates="state.disabledDatesCheckIn"
              v-model="data.checkin"
              placeholder="Check-in">
            </datepicker>
          </div>
          <small class="error_check" v-if="error_checkin">Selecione o dia do checkin</small>
        </div> <!-- col -->

        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
          <label for="datepicker-out">{{$t('reserva.saida')}}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <img src="../../assets/png/glyphicons-46-calendar.png" class="img-input" alt="Check-out">
              </div>
            </div>
            <datepicker
              id="datepicker-out"
              class="input-datepicker"
              :language="lang"
              :disabledDates="state.disabledDatesCheckOut"
              v-model="data.checkout"
              placeholder="Check-out">
            </datepicker>
          </div>
          <small class="error_check" v-if="error_checkout">Selecione o dia do checkout</small>
        </div> <!-- col -->

        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
          <label for="">{{$t('reserva.quantidade')}}</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <img src="../../assets/png/glyphicons-4-user.png" class="img-input" alt="Quantidade">
              </div>
            </div>

            <div class="dropdown-qtd">
              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{$t('reserva.quantidade')}}
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <div class="content-dropdown">
                  <div class="descricao">
                    {{$t('reserva.adultos')}}
                  </div>
                  <div class="botoes">
                    <button type="button" @click="adulto('+')" name="button"><img src="../../assets/png/glyphicons-433-plus.png" alt=""> </button>
                    <span>{{ data.adulto }}</span>
                    <button type="button" @click="adulto('-')" name="button"><img src="../../assets/png/glyphicons-434-minus.png" alt=""> </button>
                  </div>
                </div>

                <div class="content-dropdown">
                  <div class="descricao">
                    {{$t('reserva.criancas')}}
                  </div>
                  <div class="botoes">
                    <button type="button" @click="crianca('+')" name="button"><img src="../../assets/png/glyphicons-433-plus.png" alt=""> </button>
                    <span>{{ data.crianca }}</span>
                    <button type="button" @click="crianca('-')" name="button"><img src="../../assets/png/glyphicons-434-minus.png" alt=""> </button>
                  </div>
                </div>

                <!-- <div class="content-dropdown">
                  <div class="descricao">
                    {{$t('reserva.quartos')}}
                  </div>
                  <div class="botoes">
                    <button type="button" @click="quarto('+')" name="button"><img src="../../assets/png/glyphicons-433-plus.png" alt=""></button>
                    <span>{{ data.quarto }}</span>
                    <button type="button" @click="quarto('-')" name="button"><img src="../../assets/png/glyphicons-434-minus.png" alt=""></button>
                  </div>
                </div> -->

              </div>
            </div> <!-- dropdown -->

          </div>
        </div> <!-- col -->

        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
          <div class="input-group mb-2">
            <button @click.stop.prevent="verificarDisponibilidade()" class="btn verificar-disponibilidade" :disabled="data.checkin == '' || data.checkout == ''">
              {{$t('reserva.verificar_disponibilidade')}}
            </button>
            <!-- <router-link
              tag="button"
              class="btn verificar-disponibilidade"
              :to="{ name: 'RequestReservation', params: data }"
              :disabled="data.checkin == '' || data.checkout == ''">
              {{$t('reserva.verificar_disponibilidade')}}
            </router-link> -->
          </div>
        </div> <!-- col -->

      </div>
      <!-- <p class="white"><span class="red">*</span> {{$t('reserva.diaria_minima')}}</p> -->
      <span v-for="ob in obs">
        <p class="white"><span class="red">*</span> {{ ob }}</p>
      </span>
    </form>
  </div> <!-- row -->

</div>
</template>

<script>
import add from 'date-fns/add'
import datepicker from 'vuejs-datepicker';
import { ptBR, en, es, it, fr } from 'vuejs-datepicker/dist/locale'
import { format } from 'date-fns'
import { HOTEL_ID, OMNIBESS_API, MINIMUM_CHILD_AGE, MINIMUM_RESERVATION_DAYS } from '../../store/final'

export default {
  name: 'ReservationComponent',

  props: {
    header: Boolean,
    headerTitle: {
      type: String,
      default: ''
    },
    obs: {
      type: Array[String]
    },
  },

  data(){
    return {
      pt: ptBR,
      en,
      es,
      it,
      fr,
      lang: ptBR,
      error_checkin: false,
      error_checkout: false,

      state: {
        disabledDatesCheckIn: { to: this.$store.state.dateDisabled.disabledDatesCheckIn.to },
        disabledDatesCheckOut: { to: this.$store.state.dateDisabled.disabledDatesCheckOut.to },
      },
      data: {
        checkin: '',
        checkout: '',
        adulto: this.$store.state.dateReservation.adulto,
        crianca: this.$store.state.dateReservation.crianca
      }
    };
  },

  components: {
    datepicker
  },

  watch: {
    '$store.state.language': function() {
      let l = this.$store.state.language

      if(l == 'pt_BR') this.lang = this.pt
      else if(l == 'en') this.lang = this.en
      else if(l == 'es') this.lang = this.es
      else if(l == 'it') this.lang = this.it
      else if(l == 'fr') this.lang = this.fr
      else this.lang = this.pt
    },

    'data.checkin': function() {
      this.error_checkin = false
      const checkin = new Date(this.data.checkin)
      const minimumCheckout = add(checkin, { days: MINIMUM_RESERVATION_DAYS })

      if (this.data.checkout !== ''){
        const checkout = new Date(this.data.checkout)
        const checkoutTime = Math.max(checkout.getTime(), minimumCheckout.getTime())
        this.data.checkout = new Date(checkoutTime)
      }

      this.state.disabledDatesCheckOut.to = minimumCheckout

      this.$store.commit('setReservation', this.data)
      this.$store.commit('setDisabledDatesCheckout', this.state.disabledDatesCheckOut.to)

      // calc qtd dias
      // var timeDiff = Math.abs(this.$store.state.dateReservation.checkin - this.$store.state.dateReservation.checkout)
      // this.$store.commit('setQtdDias', Math.ceil(timeDiff / (1000 * 3600 * 24)))
    },

    'data.checkout': function() {
      this.error_checkout = false
      this.$store.commit('setReservation', this.data)
      this.$store.commit('setDisabledDatesCheckout', this.state.disabledDatesCheckOut.to)

      var checkin = new Date(this.$store.state.dateReservation.checkin).getTime();
      var checkout = new Date(this.$store.state.dateReservation.checkout).getTime();
      var timeDiff = Math.abs(checkin - checkout)
      this.$store.commit('setQtdDias', Math.ceil(timeDiff / (1000 * 3600 * 24)))
    },

    'data.adulto': function() { // ao mudar qtd de adultos, salva no store
      this.$store.commit('setReservation', this.data)
    },

    'data.crianca': function() { // ao mudar qtd de criancas, salva no store
      this.$store.commit('setReservation', this.data)
    },
  },

  mounted(){
    $(document).on('click', '.content-dropdown', function(event){
       event.stopPropagation();
    });
  },

  methods: {
    adulto(f) {
      if(f == '+') this.data.adulto++;
      else if(f == '-' && this.data.adulto > 1) this.data.adulto--;
    },
    crianca(f) {
      if(f === '+') this.data.crianca++;
      else if(f === '-' && this.data.crianca > 0) this.data.crianca--;
    },
    getBrowserLang(language) {
      language = (language || '').toLowerCase()
      switch (language) {
        case 'pt_br': return 'pt-BR'
        case 'en': return 'en-US'
        case 'fr': return 'fr-FR'
        case 'es': return 'es-ES'
        case 'it': return 'it-IT'
        default: return navigator.language || navigator.userLanguage
      }
    },
    verificarDisponibilidade() {
      const q = HOTEL_ID
      const lang = this.getBrowserLang(this.$store.state.language)
      const ad = this.data.adulto || 1
      const ch = this.data.crianca || 0
      const checkin = format(this.data.checkin, 'ddMMyyyy')
      const checkout = format(this.data.checkout, 'ddMMyyyy')
      const listag = []
      for (let i = 0; i < ch; i++) listag.push(MINIMUM_CHILD_AGE)
      const ag = listag.join(';')

      const url = new URL(OMNIBESS_API)
      url.searchParams.append('q', q)
      url.searchParams.append('lang', lang)
      url.searchParams.append('CheckIn', checkin)
      url.searchParams.append('CheckOut', checkout)
      url.searchParams.append('ad', ad)
      url.searchParams.append('ch', ch)
      url.searchParams.append('ag', ag)
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="css">
div.reservation-component {
  width: 100%;
  padding: 5px;
}
.reservation-component form.form-div-reservation {
  width: 100%;
  margin-top: 30px;
  padding: 10px 20px 10px 20px;
  border-radius: 5px;
  border: 1px solid rgb(03, 142, 164);
  background-color: rgb(23, 162, 184);
  /* border: .5px solid rgb(118, 106, 49); */
  /* background-color: rgb(0, 38, 62); */
  box-shadow: 3px 3px 10px #666;
}
.header-reservation {
  text-align: center;
  /* color: black !important; */
  color:white;
  margin-top: 10px;
  margin-bottom: 10px;
}
.reservation-component form.form-div-reservation p.desconto {
  color: white;
  font-weight: 800;
  text-align: center;
}
.reservation-component form.form-div-reservation label {
  color: white;
}

div .input-group .input-group-prepend .input-group-text img.img-input {
  width: 15px;
}

* .input-datepicker input {
  padding: 6px;
  width: 216px;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: 1px solid #ced4da;
}
.error_check {
  color: red;
}
@media (max-width: 575.98px) {
  * .input-datepicker input {
    width: 216px !important;
  }
  .dropdown-qtd button {
    width: 216px !important;
  }
}
@media (max-width: 767.98px) {
  * .input-datepicker input {
    width: 216px !important;
  }
  .dropdown-qtd button {
    width: 216px !important;
  }
}
@media (max-width: 991.98px) {
  * .input-datepicker input {
    width: 150px !important;
  }
  .dropdown-qtd button {
    width: 150px !important;
  }
}
@media (max-width: 1199.98px) {
  * .input-datepicker input {
    width: 150px !important;
  }
  .dropdown-qtd button {
    width: 150px !important;
  }
}
@media (min-width: 1199.98px) {
  * .input-datepicker input {
    width: 216px !important;
  }
  .dropdown-qtd button {
    width: 216px !important;
  }
}

.dropdown-qtd button {
  background-color: white;
  color: black;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: 1px solid #ced4da;
}
.dropdown-qtd button:HOVER {
  background-color: white;
  color: black;
  border: 1px solid #ced4da;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  background-color: white;
  color: black;
  border: 1px solid #ced4da;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none;
}

.dropdown-qtd .dropdown-menu {
  padding: 10px;
  cursor: pointer;
  background-color: white;
  border: none;
  font-size: .9rem;
  font-weight: 700;
  text-transform: uppercase;
  font-family: 'Open Sans', 'Helvetica Neue', Arial, sans-serif;
}
.dropdown-qtd .dropdown-item-select {
  color: black;
}
* div.content-dropdown {
  margin-top: 5px;
}
* div.descricao {
  display: inline-block;
  width: 75px;
  cursor: default;
}
* div.botoes {
  display: inline-block;
  width: 100px;
}
* div.botoes button {
  width: 25px !important;
  padding: 2px;
}
* div.botoes span {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 20px;
}
* div.botoes button img {
  width: 15px;
}
* .verificar-disponibilidade {
  margin: 32px auto;
  margin-bottom: 0;
  color: white !important;
  background-color: rgb(0, 38, 62) !important;
}
* .verificar-disponibilidade:hover {
  color: white !important;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/reservation-component/ReservationComponent.vue